(function() {
  'use strict';

  angular.module('ringbaPortal.services').factory('publisherRegistrationService', publisherRegistrationService);

  function publisherRegistrationService(
    $http,
    $q,
    utils,
    ngAuthSettings
  ) {
    'ngInject';

    const service = {
      getPublicPRPDetails: getPublicPRPDetails,
      submitPRPForm: submitPRPForm,
      getPRPById: getPRPById,
      getDefaultPRP: getDefaultPRP,
      createPRP: createPRP,
      updatePRP: updatePRP
    };

    return service;

    function createPRP(accountId, prp, setAsDefault){
      const url = _serviceBaseUrl(accountId);
      const newPRP = _initPRPCreateRequest(prp, setAsDefault);

      return $http.post(url, newPRP).then(utils.rejectPromiseOnAPIError);
    }

    function updatePRP(accountId, prp){
      const url = _serviceBaseUrl(accountId, prp.id);
      const newPRP = _initPRPPatchRequest(prp);

      return $http.patch(url, newPRP).then(utils.rejectPromiseOnAPIError);
    }

    function getDefaultPRP(accountId){
      return getPRPById(accountId, 'default');
    }

    function getPRPById(accountId, prpId){
      const url = _serviceBaseUrl(accountId, prpId);
      return $http.get(url).then(utils.rejectPromiseOnAPIError);
    }

    function getPublicPRPDetails(prpId) {
      const url = _servicePublicBaseUrl(prpId);
      return $http.get(url);
    }

    function submitPRPForm(prpId, formData){
      const url = _servicePublicBaseUrl(prpId);
      return $http.post(url, formData).then(utils.rejectPromiseOnAPIError);
    }

    function _servicePublicBaseUrl(prpId) {
      return ngAuthSettings.apiServiceBaseUri + 'PublisherSignup/' + prpId;
    }

    function _serviceBaseUrl(accountId, prpId){
      let result = ngAuthSettings.apiServiceBaseUri + accountId + '/publisher-registration';

      if(prpId){
        result += '/' + prpId;
      }

      return result;
    }

    function _initPRPPatchRequest(prp){
      const result = {
        name: prp.name || '',
        enabled: !!prp.enabled,
        description: prp.description || '',
        contactEmail: prp.contactEmail || '',
        requireAgreementToTerms: !!prp.requireAgreementToTerms,
        customPublisherFields: prp.customPublisherFields || null,
        termsAndConditions: prp.termsAndConditions,
        isTermsAndConditionsURL: prp.isTermsAndConditionsURL,
      };

      return result;
    }

    function _initPRPCreateRequest(prp, setAsDefault){
      const result = {
        name: prp.name || '',
        enabled: !!prp.enabled,
        description: prp.description || '',
        contactEmail: prp.contactEmail || '',
        requireAgreementToTerms: !!prp.requireAgreementToTerms,
      };

      if(prp.customPublisherFields){
        result.customPublisherFields = prp.customPublisherFields;
      }

      if(setAsDefault === true){
        result.setAsDefault = true;
      }

      if(prp.requireAgreementToTerms){
        result.termsAndConditions = prp.termsAndConditions;
        result.isTermsAndConditionsURL = prp.isTermsAndConditionsURL;
      }

      return result;
    }
  }
})();
